




















<template>
  <v-app class="grey darken-3">
    <core-toolbar />

    <core-drawer v-if="notAForm()" />

    <core-jumbotron v-if="notAForm()" />
    <br v-if="!notAForm()">
    <br v-if="!notAForm()">
    <core-view />

    <core-footer v-if="notAForm()" id="footer" />

  </v-app>
</template>

<script>
export default {
 methods: {
  notAForm() {
   if (this.$route.path.includes('form')) {
    return false
   } else {
    return true
   }
  },
 },
}
</script>




<style>
</style>
